import {
    AfterViewInit,
    Component,
    forwardRef,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from "@angular/forms";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";
import { RequiredDirective } from "../../directives/required/required.directive";
import { InfoComponent } from "../info/info.component";
import { NgSelectComponent, NgMultiLabelTemplateDirective } from "@ng-select/ng-select";
import { ValidationMessageComponent } from "../../validation/validation-message/validation-message.component";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TagComponent)
        }
    ],
    selector: "rask-tag",
    styleUrls: ["./tag.component.scss"],
    templateUrl: "./tag.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RequiredDirective,
        InfoComponent,
        NgSelectComponent,
        FormsModule,
        NgMultiLabelTemplateDirective,
        ValidationMessageComponent
    ]
})
export class TagComponent extends ControlValueAccessorBaseComponent implements AfterViewInit, OnInit, ControlValueAccessor {
    @Input() selected: string[] = null;
    @Input() clearAllTooltipText: string;

    constructor() {
        super();
    }

    onSelectionChange($event: any) {
        this.value = $event;
    }

    ngOnInit() {
        super.ngOnInit();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }
}
